export default {
      id: "icon-menu-burger-usage",
      viewBox: "0 0 37 37",
      url: "../icon/" + "icons.svg#icon-menu-burger-usage",
      toString: function () {
        return this.url;
      }
    }